import { api } from 'app/config/apiConfig';
import { Pagination } from 'app/types/common';
import { Box, getUnitsApi } from 'entities/Box';
import { UnitType } from 'entities/Contract';

interface GetBoxesSuggestionResponse extends Pagination<Box> {
  noAvailableBoxes: boolean;
}

export const getBoxesSuggestionApi = api.injectEndpoints({
  endpoints: (build) => ({
    getBoxesSuggestion: build.query<GetBoxesSuggestionResponse, string>({
      queryFn: async (sizeCodeId, api) => {
        let noAvailableBoxes = false;

        const availableBoxes = api.dispatch(
          getUnitsApi.endpoints.getUnits.initiate({
            sizeCodeId,
            isAvailable: true,
            unitType: UnitType.BOX,
          }),
        );
        const availableResponse = await availableBoxes.unwrap();

        if (!availableResponse.content.length) {
          noAvailableBoxes = true;

          const randomBoxes = api.dispatch(
            getUnitsApi.endpoints.getUnits.initiate({
              sizeCodeId,
              isAvailable: false,
            }),
          );
          const randomResponse = await randomBoxes.unwrap();

          return {
            data: { ...randomResponse, noAvailableBoxes },
          };
        }

        return {
          data: { ...availableResponse, noAvailableBoxes },
        };
      },
      providesTags: ['Available boxes'],
    }),
  }),
});

export const { useGetBoxesSuggestionQuery } = getBoxesSuggestionApi;
